import { SvgProps } from "@/utils/types";

export const Envelope = ({
  primaryColor = "#F66E09",
  outlineColor = "#01685E",
  className,
}: SvgProps) => (
  <svg
    width="28"
    height="23"
    className={className}
    viewBox="0 0 28 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.9394 11.2668L26.0506 18.551C26.1349 18.2812 26.1808 17.9938 26.1808 17.6963V4.68377C26.1808 4.38481 26.1342 4.09603 26.0491 3.82471L18.9387 11.2668H18.9394Z"
      fill={primaryColor}
    />
    <path
      d="M13.9996 14.1912C12.7521 14.1912 11.5482 13.6572 10.3371 12.5625L3.0376 20.0395C3.50386 20.3676 4.07124 20.5618 4.68372 20.5618H23.3162C23.9287 20.5618 24.496 20.3683 24.9623 20.0395L17.6628 12.5625C16.4495 13.658 15.2471 14.1919 14.0003 14.1919L13.9996 14.1912Z"
      fill={primaryColor}
    />
    <path
      d="M1.95026 3.82397C1.86443 4.0953 1.8186 4.38408 1.8186 4.68377V17.6963C1.8186 17.9938 1.86443 18.2811 1.94881 18.551L9.05992 11.2668L1.95026 3.82397Z"
      fill={primaryColor}
    />
    <path
      d="M13.9996 12.3725C14.9103 12.3725 15.8545 11.8524 16.8874 10.7817L24.9558 2.33578C24.491 2.00991 23.9258 1.81787 23.3155 1.81787H4.68376C4.0742 1.81787 3.509 2.00991 3.04419 2.33506L11.1155 10.7846C12.1448 11.8517 13.0897 12.3718 14.0004 12.3718L13.9996 12.3725Z"
      fill={primaryColor}
    />
    <path
      d="M23.3162 0H4.68376C2.10075 0 0 2.10075 0 4.68376V17.6963C0 20.2786 2.10075 22.3801 4.68376 22.3801H23.3162C25.8985 22.3801 28 20.2793 28 17.6963V4.68376C28 2.10147 25.8993 0 23.3162 0ZM4.68376 1.81851H23.3162C23.9258 1.81851 24.491 2.01055 24.9565 2.33642L16.8882 10.7823C15.856 11.8523 14.9111 12.3732 14.0004 12.3732C13.0897 12.3732 12.1455 11.8531 11.1155 10.786L3.04419 2.3357C3.509 2.00982 4.0742 1.81851 4.68376 1.81851ZM1.81851 17.6963V4.68376C1.81851 4.38407 1.86507 4.09602 1.95017 3.82397L9.05983 11.2668L1.94872 18.551C1.86434 18.2811 1.81851 17.9938 1.81851 17.6963ZM23.3162 20.5608H4.68376C4.07129 20.5608 3.50391 20.3673 3.03764 20.0386L10.3372 12.5616C11.549 13.6563 12.7521 14.1902 13.9996 14.1902C15.2471 14.1902 16.4495 13.6563 17.6621 12.5608L24.9616 20.0378C24.4954 20.3659 23.928 20.5601 23.3155 20.5601L23.3162 20.5608ZM26.1815 17.6963C26.1815 17.9938 26.1357 18.2811 26.0513 18.551L18.9402 11.2668L26.0506 3.8247C26.1357 4.09602 26.1822 4.3848 26.1822 4.68376V17.6963H26.1815Z"
      fill={outlineColor}
    />
  </svg>
);
